import { Controller } from "@hotwired/stimulus";

// Search-box and tag-chip helpers for the songs search form. Works beside
// async-form: it shows the clear (x) button only when the box has text,
// clears the box (and any chips) and re-submits, and, on the songs index
// (syncUrl), keeps the URL in step with the form so reload and back work.
export default class extends Controller {
  static targets = ["input", "clearButton", "chip", "clearAll", "form"];
  static values = { syncUrl: Boolean };

  connect() {
    this.refresh();
  }

  refresh() {
    const hasText = this.inputTarget.value !== "";
    this.clearButtonTarget.hidden = !hasText;
    if (this.hasClearAllTarget) {
      this.clearAllTarget.hidden = !hasText && !this.chipTargets.some((c) => c.checked);
    }
  }

  // The x button and Escape: empty the box, re-submit, keep typing.
  clearSearch(event) {
    if (event.type === "keydown") {
      if (event.key !== "Escape" || this.inputTarget.value === "") return;
      event.preventDefault();
    }
    this.inputTarget.value = "";
    this.refresh();
    this.formTarget.requestSubmit();
    this.inputTarget.focus();
  }

  // "Clear all": search text and chips.
  clearAll(event) {
    event.preventDefault();
    this.inputTarget.value = "";
    this.chipTargets.forEach((chip) => (chip.checked = false));
    this.refresh();
    this.formTarget.requestSubmit();
    this.inputTarget.focus();
  }

  submitted() {
    this.refresh();
    if (!this.syncUrlValue) return;

    const params = new URLSearchParams();
    for (const [key, value] of new FormData(this.formTarget)) {
      if (value !== "") params.append(key, value);
    }
    history.replaceState(null, "", `${location.pathname}?${params}`);
  }
}
